import { useState } from "react";
import Button from "../../../utils/components/Button";
import Input from "../../../utils/components/Input";
import CanvasDraw from "react-canvas-draw";
import { uniqueId } from "lodash";
import { useParams } from "react-router";
import { useEffect } from "react";
import { Translate } from "react-localize-redux";
import { confirmAlert } from "react-confirm-alert";
import AlertModal from "../../../utils/components/AlertModal";

const SignaturePad = ({ disabled, onSave, value }) => {
  const [saveableCanvas, setSaveableCanvas] = useState(null);
  const [name, setName] = useState(value?.name || "");
  const [isSaved, setIsSaved] = useState(false);
  const [nameError, setNameError] = useState("");
  const [signed, setSigned] = useState(false);
  const [signAgain, setSignAgain] = useState(false);

  const [inputId] = useState(uniqueId("signature-"));

  const { id } = useParams();

  useEffect(() => {
    if (value?.obj) {
      setSigned(true);
    }
  }, [value]);

  useEffect(() => {
    if (id && saveableCanvas) {
      saveableCanvas.eraseAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (nameError) {
      setNameError("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  return (
    <div className="row w-100">
      <Translate>
        {({ translate }) => (
          <div className="col-12 d-flex flex-column flex-lg-row algin-items-center border border-2 rounded mt-4 ps-0">
            {disabled || (signed && !signAgain) ? (
              value?.obj ? (
                <img
                  src={value.obj}
                  alt={`${value.name} signature`}
                  className="mw-100"
                  style={{ maxHeight: "200px" }}
                />
              ) : (
                <div className="d-flex w-100" style={{ height: "200px" }}></div>
              )
            ) : (
              <>
                <CanvasDraw
                  ref={(canvasDraw) => setSaveableCanvas(canvasDraw)}
                  className="border border-1"
                  disabled={disabled || isSaved}
                  lazyRadius={0}
                  brushRadius={1}
                  canvasWidth={550}
                  canvasHeight={200}
                  brushColor="#000"
                  imgSrc={value || ""}
                />
                <div className="ms-2">
                  <Button
                    className="btn-secondary btn-sm mt-2"
                    onClick={() => {
                      if (disabled) return;
                      saveableCanvas.eraseAll();
                      setName("");
                      onSave({ sign: null, name: "" });
                      setIsSaved(false);
                    }}
                  >
                    Temizle
                  </Button>
                  {!isSaved && (
                    <Button
                      className="btn-secondary btn-sm mt-2"
                      onClick={() => {
                        if (disabled) return;

                        if (saveableCanvas.lines.length === 0) {
                          confirmAlert({
                            customUI: ({ onClose }) => (
                              <AlertModal
                                buttons={[
                                  {
                                    label: translate("okay"),
                                    onClick: () => onClose(),
                                    classNames: "btn-primary",
                                  },
                                ]}
                                message={translate(
                                  "forms.signature_empty_error"
                                )}
                              />
                            ),
                          });
                          return;
                        }

                        if (!name) {
                          document.getElementById(inputId).focus();
                          setNameError(translate("forms.signature_name_error"));
                          return;
                        }

                        if (saveableCanvas) {
                          onSave({ sign: saveableCanvas.getDataURL(), name });
                          //returns png:base64
                          setIsSaved(true);
                        }
                      }}
                    >
                      {translate("save")}
                    </Button>
                  )}
                </div>
              </>
            )}
            <div className="d-flex flex-column align-items-center justify-content-center me-4">
              <p className="fs-6 fw-bold text-uppercase">
                {translate("forms.signed_by")}
              </p>
              <Input
                type="text"
                required={true}
                value={name}
                onChange={(e) => setName(e.target.value)}
                disabled={disabled || isSaved || (signed && !signAgain)}
                inputProps={{
                  id: inputId,
                }}
                error={nameError}
              />

              {signed && !signAgain && !disabled && (
                <Button
                  className="btn-secondary btn-sm mt-2"
                  onClick={() => {
                    setSignAgain(true);
                  }}
                >
                  {translate("forms.sign_again")}
                </Button>
              )}
            </div>
          </div>
        )}
      </Translate>
    </div>
  );
};
export default SignaturePad;
